var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import PropTypes from 'prop-types';
import { handleAd } from '../../utils/handleAd.js';
/**
 * 定义 Ad 组件
 */
class Ad extends React.PureComponent {
    constructor(props) {
        super(props);
        this.container = React.createRef();
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { content } = this.props;
            try {
                const callbackFn = yield handleAd(content);
                callbackFn(this.container.current, content.data);
            }
            catch (error) {
                const adData = {};
                error.message = `AdError - ${error.message};`;
                error.message += `AdInfo - ${JSON.stringify(adData)}`;
                console.error(error);
                console.error('AdError - AdData', adData);
                if (window && window.BJ_REPORT)
                    window.BJ_REPORT.report(error, false, 'ad');
            }
        });
    }
    /**
     * 渲染组件
     */
    render() {
        const { styleName } = this.props;
        return React.createElement("div", { className: styleName, ref: this.container });
    }
}
Ad.propTypes = {
    content: PropTypes.object,
    styleName: PropTypes.string,
};
class AdExtend extends React.Component {
    render() {
        const { styleName, content } = this.props;
        if (content) {
            return React.createElement(Ad, { styleName: styleName, content: content });
        }
        else {
            return React.createElement("div", null);
        }
    }
}
AdExtend.propTypes = {
    content: PropTypes.object,
    styleName: PropTypes.string,
};
export default AdExtend;
